import * as React from "react";

function Price() {
  return <div className="current-price-api">0.87</div>;
}

export default Price;
